import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './css/About.css';

const featureItems = [
  { key: 'timetable', icon: '\uD83D\uDCC5', color: '#4a90d9' },
  { key: 'todo', icon: '\u2705', color: '#43a047' },
  { key: 'timer', icon: '\u23F1\uFE0F', color: '#e65100' },
  { key: 'statistics', icon: '\uD83D\uDCCA', color: '#7b1fa2' },
  { key: 'goal', icon: '\uD83C\uDFAF', color: '#d32f2f' },
  { key: 'recurring', icon: '\uD83D\uDD04', color: '#00897b' },
  { key: 'observer', icon: '\uD83D\uDC41\uFE0F', color: '#5c6bc0' },
  { key: 'streak', icon: '\uD83D\uDD25', color: '#ff6f00' },
  { key: 'share', icon: '\uD83D\uDCE4', color: '#1976d2' },
  { key: 'darkmode', icon: '\uD83C\uDF19', color: '#37474f' },
  { key: 'multilingual', icon: '\uD83C\uDF10', color: '#0097a7' },
  { key: 'oauth', icon: '\uD83D\uDD11', color: '#f4511e' },
];

const About = () => {
  const { t } = useTranslation();

  return (
    <div className="about-container">
      <h1>{t('about.title')}</h1>

      <section className="about-section">
        <h2>{t('about.introduction.title')}</h2>
        <p>{t('about.introduction.description')}</p>
      </section>

      <section className="about-section">
        <h2>{t('about.features.title')}</h2>
        <div className="about-feature-grid">
          {featureItems.map(({ key, icon, color }) => (
            <div key={key} className="about-feature-card">
              <div className="about-feature-icon" style={{ background: color }}>
                {icon}
              </div>
              <div className="about-feature-name">
                {t(`about.features.${key}.name`)}
              </div>
              <div className="about-feature-desc">
                {t(`about.features.${key}.desc`)}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="about-section">
        <h2>{t('about.version.title')}</h2>
        <p>{t('home.version')}</p>
      </section>

      <section className="about-section">
        <h2>{t('about.ai.title')}</h2>
        <Link to="/ai-usage" className="about-link">{t('about.ai.link')}</Link>
      </section>

      <section className="about-section">
        <h2>{t('about.privacy.title')}</h2>
        <Link to="/privacy" className="about-link">{t('about.privacy.link')}</Link>
      </section>

      <section className="about-section">
        <h2>{t('about.contact.title')}</h2>
        <p>{t('about.contact.site')}</p>
      </section>

      <Link to="/" className="about-back-btn">
        {t('backToHome')}
      </Link>
    </div>
  );
};

export default About;
